const translate = require("deepl");

function ft_split(line, lang) {
	const split = "split_" + lang;
	line[split] = line[lang].split(" ").filter((x) => x);
	line.split_fr = line.fr.split(" ").filter((x) => x);
	return line;
}

export function clean(song) {
	const { lang } = song;
	const parsed_lines = song.parsed_lines.filter((line) => {
		if (line.fr === " " || line[lang] === " ") return false;
		return true;
	});
	return parsed_lines;
}

export function break_by_word(parsed_lines, lang) {
	// Parse lines
	for (let i = 0; i < parsed_lines.length; i++)
		if (parsed_lines[i][lang])
			parsed_lines[i] = ft_split(parsed_lines[i], lang);
	return parsed_lines;
}

export async function deepl_translate(text, lang) {
	const source_lang = lang.toUpperCase();
	const trans = await translate({
		text,
		source_lang,
		formality: "less",
		target_lang: "FR",
		auth_key: "9817759a-43b8-db92-f12e-7ebb6488d7c9",
		split_sentences: "1",
	});
	return trans.data.translations[0].text;
}
